import React from 'react';
import { XIcon } from 'lucide-react';
import AIAssistantChat, { AIAssistantChatProps } from './AIAssistantChat';

// Re-export for backward compatibility
export { AiIcon } from './AIAssistantChat';

export interface AIInsightsDrawerProps extends AIAssistantChatProps {
  isOpen: boolean;
  onClose: () => void;
}

const AIInsightsDrawer: React.FC<AIInsightsDrawerProps> = ({
  isOpen,
  onClose,
  ...chatProps
}) => {
  return (
    <>
      {/* Backdrop */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-20 z-40 transition-opacity"
          onClick={onClose}
        />
      )}

      {/* Drawer */}
      <div
        className={`fixed top-0 right-0 h-full w-[450px] max-w-full bg-white shadow-2xl z-[5000000000] flex flex-col transform transition-transform duration-300 ease-in-out ${isOpen ? 'translate-x-0' : 'translate-x-full'
          }`}
      >
        {/* Close button — overlaid on top-right */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 z-10 p-1.5 text-gray-400 hover:text-gray-600 hover:bg-blue-100 transition-colors rounded"
        >
          <XIcon className="h-5 w-5" />
        </button>

        {/* Chat fills the drawer */}
        <AIAssistantChat isOpen={isOpen} {...chatProps} />
      </div>
    </>
  );
};

export default AIInsightsDrawer;
